import { 
  Wallet, 
  Shield, 
  RefreshCw, 
  ClipboardCheck, 
  FileText, 
  Truck 
} from 'lucide-react';
import { useI18n } from '@/lib/i18n';
import { cn } from '@/lib/utils';

const services = [
  { key: 'financing', icon: Wallet, span: 'col-span-1 md:col-span-2' },
  { key: 'warranty', icon: Shield, span: 'col-span-1' },
  { key: 'tradeIn', icon: RefreshCw, span: 'col-span-1' },
  { key: 'inspection', icon: ClipboardCheck, span: 'col-span-1' },
  { key: 'documentation', icon: FileText, span: 'col-span-1' },
  { key: 'delivery', icon: Truck, span: 'col-span-1 md:col-span-2' },
] as const;

export function ServicesSection() {
  const { t } = useI18n();

  return (
    <section id="servicos" className="py-20">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            {t.services.title}
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            {t.services.subtitle}
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {services.map((service, index) => {
            const Icon = service.icon;
            const serviceData = t.services[service.key as keyof typeof t.services];
            
            if (typeof serviceData === 'string') return null;

            return (
              <div
                key={service.key}
                className={cn(
                  'glass-card p-6 transition-all duration-300 hover:scale-[1.02] group',
                  service.span
                )}
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex items-start gap-4">
                  <div className="p-3 rounded-2xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                    <Icon className="h-6 w-6" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold mb-2">
                      {serviceData.title}
                    </h3>
                    <p className="text-muted-foreground text-sm">
                      {serviceData.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
